module.exports = __webpack_public_path__ + "img/mealreminder-user-3.c0ea86e3.png";